import { render, staticRenderFns } from "./paymentAuthorization.vue?vue&type=template&id=c7da1fa4&scoped=true"
import script from "./paymentAuthorization.vue?vue&type=script&lang=js"
export * from "./paymentAuthorization.vue?vue&type=script&lang=js"
import style0 from "./paymentAuthorization.vue?vue&type=style&index=0&id=c7da1fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7da1fa4",
  null
  
)

export default component.exports